import moment from "moment";
export function validRedemptionRules(RedemptionRules) {
  let nowDate = moment().utc();
  let validRedemptionRules = RedemptionRules.filter(
    pt =>
      !pt.IsDisabled &&
      (!pt.ExpiredDate ||
        (pt.ExpiredDate &&
          moment(pt.ExpiredDate.seconds * 1000)
            .utc()
            .isAfter(nowDate)))
  );
  return validRedemptionRules.sort((a, b) => {
    return a.DiscountRate - b.DiscountRate;
  });
}
export function redemptionMatchConditions(
  RedemptionRule,
  userRedemptionPoints,
  redemptionLocalUsedPoints
) {
  return (
    userRedemptionPoints - redemptionLocalUsedPoints >= RedemptionRule.Point
  );
}

export function calcSavedPoints(RedemptionRules, orderItems) {
  var points = 0;
  for (var orderItem of orderItems) {
    for (var RedemptionRule of RedemptionRules) {
      //meet conditions
      var matchConditions = true;
      //ProductCategoryConditions
      if (RedemptionRule.Categories && RedemptionRule.Categories.length > 0) {
        matchConditions =
          RedemptionRule.Categories.filter(
            p =>
              !orderItem.ProductCategoryIDs ||
              !orderItem.ProductCategoryIDs.includes(p.toString())
          ).length == 0;
      }
      //ProductTagConditions
      if (
        matchConditions &&
        RedemptionRule.Tags &&
        RedemptionRule.Tags.length > 0
      ) {
        matchConditions =
          RedemptionRule.Tags.filter(
            p =>
              !orderItem.ProductTagIDs ||
              !orderItem.ProductTagIDs.includes(p.toString())
          ).length == 0;
      }
      if (matchConditions) {
        points += orderItem.RewardPoint;
        break;
      }
    }
  }
  return points;
}
